var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row generic-banner"},[_c('div',{staticClass:"col-md-9 col-12"},[_vm._m(0),(_vm.description)?_vm._m(1):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"generic-banner__header"},[_vm._v(" "+_vm._s(_vm.header)+" ")])
},function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"generic-banner__description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])
}]

export { render, staticRenderFns }